module.exports = __webpack_public_path__ + "static/media/main_logo_alt.f40351f8.png";